<template>
  <div :class="$style.wrapper">
    <ViddseeLicensingQA />

    <div :class="$style.navigation">
      <small><i class="el-icon-back"/></small>
      <!-- Use URL link -->
      <a href="/dashboard">Back to dashboard</a>
    </div>
  </div>
</template>

<script>
import ViddseeLicensingQA from '../components/ViddseeLicensingQA';

export default {
  components: {
    ViddseeLicensingQA,
  },
};
</script>

<style lang="scss" module>
.wrapper {
  max-width: 21cm;
  margin-left: auto;
  margin-right: auto;
}

.navigation {
  margin-top: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/FrequentlyAskedQuestion/pages/Licensing.vue